// docs.js
export const docs = {
  resume: require("../content/docs/Abby Jetmundsen Resume.pdf"),
};
